<template>
  <div id="aedes_aegypti" class="row">
    <div class="col-md-12">
      <SelectsV2
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      />
    </div>
    <div class="col-md-12">
      <b-tabs fill class="esus-feedback-tabs" v-model="tabsActive">
        <b-tab title="Lista" active>
          <template v-slot:title> <i class="icofont-list"></i> Lista </template>
          <div class="row">
            <div class="full-table">
              <div class="col-md-12">
                <div class="info-table">
                  <div class="info-table-item">
                    <Subtitle
                      @exibirVermelhos="handleExibirVermelhos"
                      @exibirVerdes="handleExibirVerdes"
                      :setColor="setColor"
                      @resetColor="resetColor"
                      :setRed="exibirCadastrosVermelhos"
                      :setGreen="exibirCadastrosVerdes"
                    ></Subtitle>
                  </div>
                  <div class="info-table-item">
                    <download-files
                      :callback-pdf="generatePdf"
                      :data="displayedCadastros"
                      :fields="dataFields"
                      name="aedes-aegypti"
                    >
                    </download-files>
                  </div>
                </div>
                <tabela-cadastros
                  ref="table"
                  :cadastros="displayedCadastros"
                  :loading="loading"
                  @filterSearch="filterSearch($event)"
                ></tabela-cadastros>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Mapa" @click="loadMap()">
          <template v-slot:title>
            <i class="icofont-ui-map"></i> Mapa
          </template>
          <div class="row">
            <div class="col-12">
              <div class="info-table">
                <div class="info-table-item">
                  <Subtitle
                    @exibirVermelhos="handleExibirVermelhos"
                    @exibirVerdes="handleExibirVerdes"
                    :setColor="setColor"
                    @resetColor="resetColor"
                    :setRed="exibirCadastrosVermelhos"
                    :setGreen="exibirCadastrosVerdes"
                  ></Subtitle>
                </div>
              </div>
            </div>
            <div class="col-12 mapa">
              <l-map
                :zoom.sync="zoom"
                :center="center"
                style="height: 500px; width: 100%"
                ref="map"
                :options="{ zoomControl: false }"
              >
                <l-tile-layer :url="url" :attribution="attribution" />
                <l-control-zoom position="bottomright"></l-control-zoom>
                <!--  <l-marker
                      :lat-lng="[`${markerLatLng[0]}`, `${markerLatLng[1]}`]"
                      :icon="iconColor('2022-04-12', '1')"
                    >
                    </l-marker> -->

                <l-marker
                  v-for="(pessoa, index) in cadastrosMapa"
                  :key="'marker-' + index"
                  :lat-lng="[
                    `${pessoa.latitude ? pessoa.latitude : '0'}`,
                    `${pessoa.longitude ? pessoa.longitude : '0'}`,
                  ]"
                  :icon="iconColor(pessoa.dias)"
                >
                  <l-tooltip>
                    <div class="tooltip-latlgn">
                      {{ pessoa.no_cidadao }}
                    </div>
                  </l-tooltip>
                </l-marker>
              </l-map>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import TabelaCadastros from './TabelaCadastros.vue'
import * as Functions from './functions.js'
import mapa from '@/pages/PrevineBrasil/arquivos/mapa_ranking_regional'
import { mask } from 'vue-the-mask'
import Subtitle from './Subtitle'
import { coordinates } from '@/pages/PrevineBrasil/coordinates'
import {
  LMap,
  LCircle,
  LTileLayer,
  LCircleMarker,
  LMarker,
  LIcon,
  LTooltip,
  LControlZoom,
} from 'vue2-leaflet'
import { latLng, icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import SelectsV2 from '@/components/utils/SelectsV2.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import utils from '@/mixins/utils.js'

export default {
  name: 'AedesAegyptiPorEquipeAcs',
  directives: { mask },
  components: {
    LMap,
    LCircle,
    LTileLayer,
    LMarker,
    LIcon,
    LCircleMarker,
    LTooltip,
    LControlZoom,
    PulseLoader,
    Loader,
    Subtitle,
    TabelaCadastros,
    SelectsV2,
    DownloadFiles,
  },
  mixins: [utils],
  data() {
    return {
      /*     markerLatLng: [-16.57898541449999, -48.498747024193634], */
      iconSize: 64,
      zoom: 10,
      center: latLng(-15.2, -51.31),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      iconVerde: icon({
        iconUrl: require('@/assets/images/marcadores-mapa/pessoa-verde.svg'),
        iconSize: [32, 37],
        iconAnchor: [16, 37],
      }),
      iconVermelho: icon({
        iconUrl: require('@/assets/images/marcadores-mapa/pessoa-vermelho.svg'),
        iconSize: [32, 37],
        iconAnchor: [16, 37],
      }),
      tabsActive: 0,
      equipe: '',
      microArea: '',
      cadastros: [],
      loading: false,
      cadastrosOriginais: [],
      cadastrosMapa: [],
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      setColor: null,
      semZoom: false,
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    dynamicSize() {
      return [this.iconSize, this.iconSize * 1.15]
    },
    dynamicAnchor() {
      return [this.iconSize / 2, this.iconSize * 1.15]
    },
    equipes() {
      return this.removeDuplicate(this.$store.getters['getEquipes'], 'nu_ine')
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    async filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais
      if (vermelho === true) {
        data = Functions.exibirVermelhos(data)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(data)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      }
      this.cadastros = data
      await this.loadMap()
    },

    loadMap() {
      if (this.cadastros) {
        this.cadastrosMapa = this.cadastros.filter((item) => {
          return (
            item.latitude !== '0' &&
            item.latitude !== null &&
            item.longitude !== '0' &&
            item.longitude !== null
          )
        })
        setTimeout(() => {
          const cod_ibge = this.$store.state.cod_ibge
          const state = this.$store.state.cidade.split('-')[1].trim()
          // pega as coordenadas do municipio
          const countyCoordinates = mapa.find((item) => {
            return item.co_ibge === cod_ibge
          })

          // pega o zoom para o estado
          const coordinatesState = coordinates.find((item) => {
            return item.uf === state
          })
          const mapObject = this.$refs.map.mapObject

          mapObject.invalidateSize(true)
          // Faz com que não de zoom quando "semZoom" é true
          if (this.semZoom === false) {
            mapObject.setView(
              latLng(countyCoordinates.local[0], countyCoordinates.local[1]),
              coordinatesState.zoom + 4
            )
          }
          // Caso "semZoom" seja true o sistema reseta para false para o zoom
          // ocorrer nos outros filtros
          this.semZoom = false
        }, 500)
      } else {
        setTimeout(() => {
          const mapObject = this.$refs.map.mapObject
          mapObject.invalidateSize(true)
          mapObject.setView(this.center, 5)
        }, 500)
      }
    },

    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        this.filtros(true, false)
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = false
      }
      // Faz com que não de zoom quando esse filtro é ativado
      this.semZoom = true
    },

    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        this.filtros(false, true)
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = false
      }
      // Faz com que não de zoom quando esse filtro é ativado
      this.semZoom = true
    },

    resetColor() {
      this.setColor = false
      this.exibirCadastrosVerdes = false
      this.exibirCadastrosVermelhos = false
    },

    iconColor(dias) {
      if (dias !== null || dias !== undefined) {
        const diasInteiro = parseInt(dias)
        if (diasInteiro <= 30) {
          return this.iconVermelho
        } else {
          return this.iconVerde
        }
      } else {
        return this.iconVerde
      }
    },

    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.tabsActive = 0
        this.loading = true
        this.setColor = true
        this.equipe = event
        this.cadastros = []
        try {
          await this.buscarTodosPorEquipe()

          this.loading = false
          this.loadMap()
        } catch (error) {
          console.log(error)
        }
      } else {
        this.tabsActive = 0
        this.setColor = true
        this.equipe = ''
        this.cadastros = []
        this.cadastrosOriginais = []
      }
    },

    async onChangeMicroArea(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.tabsActive = 0
      this.setColor = true
      if (event !== null) {
        this.microArea = event.micro_area
        this.buscarDadosPorMicroArea()
      } else {
        this.cadastrosMapa = []
        this.cadastrosOriginais = []
        this.cadastros = []
        await this.onChangeEquipe(this.equipe)
        setTimeout(() => {
          const mapObject = this.$refs.map.mapObject
          this.zoom = 5
          mapObject.invalidateSize(true)
          mapObject.setView(this.center, 5)
        }, 500)
      }
    },

    async buscarTodosPorEquipe() {
      try {
        this.loading = true
        const response = await this.$api.get(
          '/app/aedes-aegypti/equipe/' +
            this.$store.state.cod_ibge +
            '/' +
            this.equipe.ine_esf_eap
        )
        if (response) {
          this.cadastros = response.data
          this.cadastrosOriginais = response.data
          this.exibirCadastrosVermelhos = true
          this.filtros(
            this.exibirCadastrosVermelhos,
            this.exibirCadastrosVerdes
          )
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    async buscarDadosPorMicroArea() {
      try {
        this.loading = true
        let response = await this.$api.get(
          '/app/aedes-aegypti/microarea/' +
            this.$store.state.cod_ibge +
            '/' +
            this.equipe.ine_esf_eap +
            '/' +
            this.microArea
        )
        if (response) {
          this.cadastros = response.data
          this.cadastrosOriginais = response.data
          this.loading = false
          this.exibirCadastrosVermelhos = true
          this.filtros(
            this.exibirCadastrosVermelhos,
            this.exibirCadastrosVerdes
          )
        } else {
          this.loading = false
        }
      } catch (error) {
        console.log(error)
      }
    },

    // Formata os dados encontrados no mapa
    getRadius(desempenho) {
      const value = parseFloat(desempenho)
      const result = value / 30
      return result
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.microArea
      )
    },
  },
}
</script>

<style scoped></style>
